import classNames from 'classnames';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import gradient1 from '../../../images/gradient-1.png';
import gradient2 from '../../../images/gradient-2.png';
import gradient125 from '../../../images/gradient1-25.png';
import gradient225 from '../../../images/gradient2-25.png';

const palette = [
  {
    title: '$black',
    color: '#202020',
    className: 'black',
    styles: {
      color: 'white'
    },
    width: 6,
  },
  {
    title: '$white',
    color: '#FFFFFF',
    className: 'white',
    styles: {
    },
    rootStyles: {
      border: '1px solid #202020',
      color: '#202020'
    },
    width: 6,
  },
  {
    title: '$blue',
    color: '#88C9EE',
    className: 'blue',
    width: 4,
    styles: {
      color: '#202020'
    },
  },
  {
    title: '$gradient1',
    image: gradient1,
    width: 4
  },
  {
    title: '$gradient2',
    image: gradient2,
    width: 4
  },
  {
    title: '$gradient1-transparent',
    image: gradient125,
    color: '25% Opacity',
    width: 6
  },
  {
    title: '$gradient2-transparent',
    image: gradient225,
    color: '25% Opacity',
    width: 6
  },
  {
    title: '$grey1',
    className: 'grey1',
    color: '#666666',
    width: 3,
    styles: {
      color: 'white'
    }
  },
  {
    title: '$grey2',
    className: 'grey2',
    color: '#AAAAAA',
    width: 3
  },
  {
    title: '$grey3',
    className: 'grey3',
    color: 'CCCCCC',
    width: 3
  },
  {
    title: '$grey4',
    className: 'grey4',
    color: '#F9F9F9',
    width: 3
  },
];

const semanticPalette = [
  {
    title: '$orange',
    color: '#fa7754',
    className: 'orange',
    width: 4,
  },
  {
    title: '$pink',
    color: '#f8748c',
    className: 'pink',
    width: 4,
  },
  {
    title: '$purple',
    color: '#ad98eb',
    className: 'purple',
    width: 4,
  },
  {
    title: '$green',
    color: '#62bf61',
    className: 'green',
    width: 4,
  },
  {
    title: '$red',
    color: '#da394a',
    className: 'red',
    width: 4,
    styles: {
      color: 'white'
    }
  },
  {
    title: '$yellow',
    color: '#ffcb4b',
    className: 'yellow',
    width: 4,
  },
];

const Colors = () => {
  const { t } = useTranslation();

  return (
    <Container className="container-style-guide ">
      <h3 className="mb-4">Colors</h3>
      <Row>
        <Col sm={12} >
          <h5 className="mb-4">
            {t('influencers.pages.colors.palette')}
          </h5>
        </Col>
      </Row>
      <Row >
        {
          palette.map(color => (
            <Col key={color.title} xs={color.width} className="mb-3">
              <div className={classNames("palette-color", color.className)} style={color.rootStyles}>
                <div className="text-medium-2" style={color.styles}>
                  {color.title}
                </div>
                <div className="text-medium-2" style={color.styles}> {color.color} </div>
                {color.image && <img src={color.image} />}
              </div>
            </Col>
          ))
        }
      </Row >
      <Row style={{ marginTop: 80 }}>
        <Col sm={12} >
          <h5 className="mb-4">
            {t('influencers.pages.colors.semantic_palette')}
          </h5>
        </Col>
      </Row>
      <Row>
        {
          semanticPalette.map(color => (
            <Col key={color.title} xs={color.width} className="mb-3">
              <div className={classNames("palette-color", color.className)} style={color.rootStyles}>
                <div className="text-medium-2" style={color.styles}>
                  {color.title}
                </div>
                <div className="text-medium-2" style={color.styles}> {color.color} </div>
                {color.image && <img src={color.image} />}
              </div>
            </Col>
          ))
        }
      </Row>
      <Row style={{ marginTop: 80 }}>
        <Col sm={12} >
          <h5 className="mb-4">
            {t('influencers.pages.colors.guidelines')}
          </h5>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={3} className="mb-4">
          <Row className="mb-4">
            <Col className="col-1"><div className="circle black"></div></Col>
            <Col className="col-1"><div className="circle white" style={{
              border: '1px solid #202020'
            }}></div></Col>
          </Row>
          <Row>
            <Col>
              {t('influencers.pages.colors.desc_black_white')}
            </Col>
          </Row>
        </Col>

        <Col xs={12} sm={3} className="mb-4">
          <Row className="mb-4">
            <Col className="col-1"><div className="circle blue"></div></Col>
          </Row>
          <Row>
            <Col>
              {t('influencers.pages.colors.desc_blue')}
            </Col>
          </Row>
        </Col>

        <Col xs={12} sm={3} className="mb-4">
          <Row className="mb-4">
            <Col className="col-1"><div className="circle gradient-1"></div></Col>
            <Col className="col-1"><div className="circle gradient-2"></div></Col>
          </Row>
          <Row>
            <Col>
              {t('influencers.pages.colors.desc_gradients')}
            </Col>
          </Row>
        </Col>

        <Col xs={12} sm={3} className="mb-4" />

        <Col xs={12} sm={3} className="mb-4">
          <Row className="mb-4">
            <Col className="col-1"><div className="circle grey4" style={{
              border: '1px solid #202020'
            }}></div></Col>
          </Row>
          <Row>
            <Col>
              {t('influencers.pages.colors.desc_grey')}
            </Col>
          </Row>
        </Col>

        <Col xs={12} sm={3} className="mb-4">
          <Row className="mb-4">
            <Col className="col-1"><div className="circle grey1"></div></Col>
            <Col className="col-1"><div className="circle grey2"></div></Col>
            <Col className="col-1"><div className="circle grey3"></div></Col>
          </Row>
          <Row>
            <Col>
              {t('influencers.pages.colors.desc_greys')}
            </Col>
          </Row>
        </Col>

        <Col xs={12} sm={3} className="mb-4">
          <Row className="mb-4">
            <Col className="col-1"><div className="circle orange"></div></Col>
            <Col className="col-1"><div className="circle pink"></div></Col>
            <Col className="col-1"><div className="circle purple"></div></Col>
            <Col className="col-1"><div className="circle green"></div></Col>
            <Col className="col-1"><div className="circle red"></div></Col>
            <Col className="col-1"><div className="circle yellow"></div></Col>
          </Row>
          <Row>
            <Col>
              {t('influencers.pages.colors.desc_colors')}
            </Col>
          </Row>
        </Col>

      </Row>
    </Container >
  );
};

export default Colors;